import axiosInstance from '../utils/axiosConfig';

export const userApi = {

        isAdmin: async () => {
        const response = await axiosInstance.get('/api/v1/users/is-admin') ;

        return response.data;
    },


        getRemainingGames: async () => {
        const response = await axiosInstance.get('/api/v1/users/games-remaining') ;

        return response.data;
    },

        getFreeGames: async () => {
        const response = await axiosInstance.get('/api/v1/users/free-games') ;

        return response.data;
    },
     

}